import styled from 'styled-components';
import { Select } from '_src/shared/form-helpers';

const PageTitle = styled.p`
  font-family: 'SF Display Heavy';
  margin-bottom: 20px;
`;

const Label = styled.div`
  margin-bottom: 5px;
`;

const Search = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-gap: 15px;
  width: 100%;
  margin-bottom: 20px;
  align-items: flex-end;

  button {
    align-self: flex-end;
    margin-left: 20px;
  }
`;

const Title = styled.span`
  font-size: 18px;
`;

// Modal
const ModalContainer = styled.div`
  margin: 0px -25px;
`;

const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  font-size: 18px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 30px;
  justify-content: end;
  width: 100%;
  margin-bottom: 20px;
`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

const FieldsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
  grid-gap: 0 15px;
`;

const HighlightedFieldsContainer = styled(FieldsContainer)`
  margin: 12px 0;
  padding: 15px;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
  border-radius: 6px;
`;

const HighlightedWarning = styled.div`
  margin: 12px 0;
  padding: 15px;
  border-radius: 6px;
  background-color: #fff4e5;
  color: #663c00;
  border: 1px solid #ffb020;
`;

const DefectsFieldsContainer = styled.div`
  column-count: 3;
  column-gap: 20px;
`;

const Warning = styled.p`
  color: #d63131;
  margin-top: 25px;
`;

const StyledSelect = styled(Select)`
  width: 300px;
  font-size: 16px;

  .ant-select-selection {
    padding: 2px !important;
    border: none;
    box-shadow: none;
    margin-left: 2px;

    .ant-select-selection__rendered {
      margin-left: 0px;
    }
  }

  &:hover .ant-select-selection,
  &:focus .ant-select-selection {
    border: none;
  }
`;

export {
  PageTitle,
  Label,
  Search,
  Title,
  ModalContainer,
  ModalHeaderContainer,
  ButtonContainer,
  FormContainer,
  FieldsContainer,
  HighlightedFieldsContainer,
  HighlightedWarning,
  DefectsFieldsContainer,
  Warning,
  StyledSelect
};
